import * as gs from "@ivanlog/gs";
import { CmpWidgetLPXDetailsBase } from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { LPXConfig, LPXReserves, LPXShare } from "../contracts/LPXContract";
import { ERC20Contract } from "../contracts/ERC20Contract";
import { BiMath } from "../libs/BiMath";

export class CmpWidgetLPXDetails extends CmpWidgetLPXDetailsBase {

    private _lpxInf:LPXInfrastructure;
    private _config:LPXConfig;
    private _poolReserve:LPXReserves;
    private _share:LPXShare;
    private _poolId:number;
    constructor() {
        super();
        this.hide();
        const ctrl = this.ctrls;
        ctrl.cmpLPXControl.hide();

        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.disable();

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.lSubText.text=
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.lSubText.text="Fund";

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.lSubText.text=
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.lSubText.text="Anchor";

        ctrl.cmpRemoveLiquidityTokens.ctrls.blockImgPlus.hide();
        ctrl.cmpRemoveLiquidityTokens.ctrls.blockImgMinus.show();

        ctrl.cmpClaimYield.ctrls.iValue.disable();
        ctrl.cmpClaimYield.ctrls.lSubText.text="Maker Profit";
        ctrl.cmpClaimArbProfit.ctrls.iValue.disable();
        ctrl.cmpClaimArbProfit.ctrls.lSubText.text="Arbitrage Profit";


        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.disable();
        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.disable();

        ctrl.btnAddLiquidity.onclick=async ()=>{
            await App.gui.awaitInLockUIAsync(this._tryAddLiquidityAsync());
        }
        ctrl.btnClaimYield.onclick=async ()=>{
            App.gui.awaitInLockUIAsync(this._tryClaimYieldAsync());
        }
        ctrl.btnRemoveLiquidity.onclick=async ()=>{
            App.gui.awaitInLockUIAsync(this._tryRemoveLiquidityAsync());
        }

        ctrl.rRemoveLiquidityPart.onChangeValue.addHandler((value)=>this._setRemoveRatio(value));
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.el.addEventListener("input",()=>this._setLiqValue());
  
        ctrl.tglAddLiquidity.active();
        ctrl.tglRemoveLiquidity.onclick=async ()=>{
            if (!ctrl.tglRemoveLiquidity.isActive) return;
            if (!this._share) this._share = await this._lpxInf.lpx.shares(this._poolId, App.chain.account);
        }
        ctrl.tglClaimYield.onclick=async ()=>{
            if (!ctrl.tglClaimYield.isActive) return;

            const anchorAdr = this._lpxInf.pAdrToAdr(this._config.anchorToken);
            ctrl.cmpClaimArbProfit.ctrls.iValue.value =
            ctrl.cmpClaimYield.ctrls.iValue.value = "loading";
            ctrl.btnClaimYield.disable();

            //const account = this._config.manager;// App.chain.account;
            const account = App.chain.account;
            if (!this._share) this._share = await this._lpxInf.lpx.shares(this._poolId, account);
            if (!this._share) return;

            const profit = await this._lpxInf.lpxCtrlPools.getProfit(this._poolId, account);
            const profitBI = BiMath.ToBI(profit)
            ctrl.cmpClaimYield.ctrls.iValue.value = BiMath.ToEth(profitBI*this._lpxInf.getDecimalCorIndex(anchorAdr)/BiMath.Decimal);
            if (profitBI>0n) ctrl.btnClaimYield.enable();

            const shareArb = await this._lpxInf.lpxLibArbProfit.getShareInfo(this._poolId, account);
            if (shareArb)
            {
                const profitArbBI = ((shareArb.pps_-shareArb.shareInfo_.debt)*this._share.share/BiMath.Decimal+shareArb.shareInfo_.pending);
                ctrl.cmpClaimArbProfit.ctrls.iValue.value = BiMath.ToEth(profitArbBI*this._lpxInf.getDecimalCorIndex(anchorAdr)/BiMath.Decimal);
                if (profitArbBI>0n) ctrl.btnClaimYield.enable();
            } else ctrl.cmpClaimArbProfit.ctrls.iValue.value = "error";
        }

    }

    private _setRemoveRatio(value){
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value =
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value = "";
        this.ctrls.btnRemoveLiquidity.disable();
        if (!this._share) { this.ctrls.rRemoveLiquidityPart.value=0; return;}
        if (!this._config) {this.ctrls.rRemoveLiquidityPart.value=0; return;}
        if (this._config.totalShares==BiMath.Zero) {this.ctrls.rRemoveLiquidityPart.value=0; return;}
        if (value>0) this.ctrls.btnRemoveLiquidity.enable();
        this.ctrls.lRemovePercent.text = value+"%";
        const takeShare = this._share.share*BiMath.Decimal/this._config.totalShares*BigInt(value)/BigInt(100);

        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value 
            = BiMath.ToEth((this._poolReserve.fundReserve*takeShare)/BiMath.Decimal*this._lpxInf.getDecimalCorIndex(this._fundAdr)/BiMath.Decimal)
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value 
            = BiMath.ToEth((this._poolReserve.anchorReserve*takeShare)/BiMath.Decimal*this._lpxInf.getDecimalCorIndex(this._acnhorAdr)/BiMath.Decimal)
    }

    private _setLiqValue(){
        const ctrl = this.ctrls.cmpAddLiquidityTokens.ctrls;
        const value = ctrl.cmpInputTokenAmount0.ctrls.iValue.value;
        if (!value) {ctrl.cmpInputTokenAmount1.ctrls.iValue.value=''; return;}
        const fundAdr = this._lpxInf.pAdrToAdr(this._config.fundToken);
        const anchorAdr = this._lpxInf.pAdrToAdr(this._config.anchorToken);
        let valueBi = BiMath.ToBI(value);
        valueBi=valueBi*this._lpxInf.getDecimal(fundAdr)/BiMath.Decimal
        ctrl.cmpInputTokenAmount1.ctrls.iValue.value =
            BiMath.ToEth(
                ((this._poolReserve.anchorReserve*BiMath.Decimal)/this._poolReserve.fundReserve)*valueBi/BiMath.Decimal
               // *BigInt(1001)/BigInt(1000)
                *this._lpxInf.getDecimalCorIndex(anchorAdr)/BiMath.Decimal
        );
    }


    private _fundAdr="";
    private _acnhorAdr="";
    public async refreshAsync(poolId:number, poolConfig:LPXConfig, poolReserve:LPXReserves)
    {
        const account = App.chain.account;   
        this._share=undefined;
        this._setRemoveRatio(0);
        this._poolId=poolId;
        this._config=poolConfig;
        this._poolReserve=poolReserve;
        const lpxInf=App.Inst.getInst(LPXInfrastructure);
        this._lpxInf=lpxInf;
        //TODO подумать о фии и переделать

        const fundAdr = this._lpxInf.pAdrToAdr(this._config.fundToken);
        const anchorAdr = this._lpxInf.pAdrToAdr(this._config.anchorToken);
        this._fundAdr = fundAdr;
        this._acnhorAdr = anchorAdr;

        const fundSymbol = await this._lpxInf.getSymbolAsync(fundAdr);
        const anchorSymbol = await this._lpxInf.getSymbolAsync(this._lpxInf.pAdrToAdr(this._config.anchorToken));
        const ctrl = this.ctrls;

        ctrl.lPoolId.text = "#"+poolId;
        if (lpxInf.hasFlag(poolConfig.pack, LPXInfrastructure.PACKFLAG_MANAGER_ONLY))
            ctrl.lPoolId.text = "SOLO #"+poolId;

        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value='';
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value='';

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpClaimYield.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpClaimArbProfit.setToken(anchorSymbol, anchorAdr);

        ctrl.cmpLPXControl.ctrls.cmpNewAnchorAdr

        ctrl.imgFund.el.src = "files/images/erc20/"+fundAdr.toLowerCase()+".webp";
        ctrl.imgAnchor.el.src = "files/images/erc20/"+anchorAdr.toLowerCase()+".webp";
        ctrl.lAnchorSymbol.text = anchorSymbol;
        ctrl.lFundSymbol.text = fundSymbol;

        ctrl.tglClaimYield.inactive();
        ctrl.tglRemoveLiquidity.inactive();

        const pack = this._lpxInf.unpackConfigPack(this._config.pack);

        //Рассчет индексов
        //let feeBI=pack.ntzIndex;//*BigInt(12)/BigInt(100)/BiMath.Decimal17B;
       // if (feeBI<BiMath.ToBI("0.0056")) feeBI=BiMath.ToBI("0.0056");
        const ntzEthP = BiMath.ToEth(pack.ntzIndex*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));
        const feeEthP =BiMath.ToEth(pack.feeIndex*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));//; BiMath.ToEth(feeBI/BigInt(2)*BigInt(100));
        const profitEthP = BiMath.ToEth(pack.profitIndex*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));
        let reinvestEthP = "0";
        if (pack.ntzIndex>pack.profitIndex+pack.feeIndex*BigInt(2))
            reinvestEthP = BiMath.ToEth((pack.ntzIndex-(pack.profitIndex+pack.feeIndex*BigInt(2)))*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));
        const managerRewardEthP = BiMath.ToEth(pack.managerRewardIndex*BiMath.Decimal/BiMath.Decimal17B*BigInt(100));
        // const rewardIndexEthP = BiMath.ToEth(BiMath.ToBI(poolConfig.rewardIndex)*BigInt(100));
        // const totalProfBi = BiMath.ToBI(rewardIndexEthP)+BiMath.ToBI(feeEthP)*BigInt(2);
        // const reinvestEthP = (totalProfBi>=BiMath.ToBI(ntzEthP)?"0":BiMath.ToEth(BiMath.ToBI(ntzEthP)-totalProfBi));

        ctrl.lAPR.text = this._lpxInf.getApr(this._poolId);
        ctrl.lNTZ.text = ntzEthP+"%";
        ctrl.lFee.text = feeEthP+"%";
        ctrl.lProfit.text = profitEthP+"%";
        ctrl.lReinvested.text = reinvestEthP+"%";
        ctrl.lManagerReward.text = managerRewardEthP+"%";
        //Рассчет цен

        ctrl.lFundAdr.text =fundAdr;
        ctrl.lAnchorAdr.text =anchorAdr;
        ctrl.lManagerAdr.text =this._config.manager;

        ctrl.btnCopyAdrFund.onclick=()=>{gs.helpers.text.copyToClipboard(fundAdr)}
        ctrl.btnCopyAdrAnchor.onclick=()=>{gs.helpers.text.copyToClipboard(anchorAdr)}
        ctrl.btnCopyAdrManager.onclick=()=>{gs.helpers.text.copyToClipboard(this._config.manager)}

        ctrl.lPriceEnd.text = 
        ctrl.lPriceBuy.text =
        ctrl.lPriceStart.text =
        ctrl.lPriceSell.text = "-";

        if (this._poolReserve.fundImgReserve>0) ctrl.lPriceEnd.text = BiMath.ToEth(this._lpxInf.calcEndRatio(this._poolReserve, pack.feeIndex)
            *this._lpxInf.getDecimalCorPairIndex(fundAdr, anchorAdr)/BiMath.Decimal);
        if (this._poolReserve.anchorImgReserve>0) ctrl.lPriceStart.text = BiMath.ToEth(this._lpxInf.calcStartRatio(this._poolReserve, pack.feeIndex)
            *(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B
            *this._lpxInf.getDecimalCorPairIndex(fundAdr, anchorAdr)/BiMath.Decimal);
        
        if (this._poolReserve.fundReserve + this._poolReserve.fundImgReserve>0)
        {
            ctrl.lPriceBuy.text = BiMath.ToEth(this._lpxInf.calcCurrentRatio(this._poolReserve)*(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B*this._lpxInf.getDecimalCorPairIndex(fundAdr, anchorAdr)/BiMath.Decimal);
            ctrl.lPriceSell.text = BiMath.ToEth(this._lpxInf.calcCurrentRatio(this._poolReserve)*this._lpxInf.getDecimalCorPairIndex(fundAdr, anchorAdr)/BiMath.Decimal);
        }

        let poolType = "Liquid";
        switch(pack.poolType)
        {
            case 1:poolType = "Single-Sided"; break;
            case 2:poolType = "Dual"; break;
            case 3:poolType = "Directional"; break;
        }
        ctrl.lType.text = poolType;

        this.show();

        if (!account)
        {
            ctrl.blockAddLiquidity.hide();
            ctrl.blockClaimYield.hide();
            ctrl.blockRemoveLiquidity.hide();
            return;
        } else
        {
            ctrl.blockAddLiquidity.show();
            ctrl.blockClaimYield.show();
            ctrl.blockRemoveLiquidity.show();
        }

        if (this._config.totalShares==0n)
        {
            ctrl.blockAddLiquidity.hide();
            ctrl.blockRemoveLiquidity.hide();
            if (account.toLocaleLowerCase()==this._config.manager.toLocaleLowerCase())
            {
                await ctrl.cmpLPXControl.refreshAsync(poolId, poolConfig, poolReserve);
                ctrl.cmpLPXControl.show();
            }
        } else
        {
            ctrl.blockAddLiquidity.show();
            ctrl.blockRemoveLiquidity.show();
            ctrl.cmpLPXControl.hide();
        }

        this._share=undefined;

        // this._share = await this._lpxInf.lpx.shares(this._poolId, App.chain.account);
        // if (!this._share) ctrl.btnAddLiquidity.disable();
        // else ctrl.btnAddLiquidity.enable();

        // ctrl.btnClaimYield.disable();
        // const profit = await this._lpxInf.lpxCtrlPools.getProfit(this._poolId, App.chain.account);
        // ctrl.cmpClaimYield.ctrls.iValue.value = BiMath.ToEth(BiMath.ToBI(profit)*this._lpxInf.getDecimalCorIndex(anchorAdr)/BiMath.Decimal);

        // if (this._share)
        // {
        //     const shareArb = await this._lpxInf.lpxLibArbProfit.getShareInfo(this._poolId, App.chain.account);
        //     if (shareArb)
        //     {
        //         const profitArb = ((shareArb.pps_-shareArb.shareInfo_.debt)*this._share.share/BiMath.Decimal+shareArb.shareInfo_.pending);
        //         ctrl.cmpClaimArbProfit.ctrls.iValue.value = BiMath.ToEth(profitArb*this._lpxInf.getDecimalCorIndex(anchorAdr)/BiMath.Decimal);
        //     } else { } //TODO подумать что делать если не смог получить данные
        // }
        // if (ctrl.cmpClaimYield.ctrls.iValue.value!="0"||ctrl.cmpClaimArbProfit.ctrls.iValue.value!="0") ctrl.btnClaimYield.enable();
    }

    private async _tryAddLiquidityAsync()
    {
        const fundAdr = this._lpxInf.pAdrToAdr(this._config.fundToken)
        const anchorAdr = this._lpxInf.pAdrToAdr(this._config.anchorToken)
        const valueFund = this.ctrls.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value;
        const valueAnchor = this.ctrls.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value;
        let valueFundBi = BiMath.ToBI(valueFund)*this._lpxInf.getDecimal(fundAdr)/BiMath.Decimal;
        let valueAnchorBi = BiMath.ToBI(valueAnchor)*this._lpxInf.getDecimal(anchorAdr)/BiMath.Decimal*BigInt(1001)/BigInt(1000);
        let valuePayBi=BiMath.Zero;

        const erc20Fund = new ERC20Contract(fundAdr, App.chain.provider);
        const erc20Anchor = new ERC20Contract(anchorAdr, App.chain.provider);
        const balanceEth = await App.chain.getBalanceEth();

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceFund = await erc20Fund.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceFund)<valueFundBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueFundBi)
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
            valuePayBi = valueFundBi;
        }

        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceAnchor = await erc20Anchor.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceAnchor)<valueAnchorBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueAnchorBi)
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
            valuePayBi = valueAnchorBi;
        }

        const stepTx0 = App.gui.getTxLockText();
        const stepTx1="1/2 Transaction in progress.\nToken approval pending.\nPlease wait for it to finish.\nThis may take a few minutes.\n\nThe second transaction will start automatically.";
        const stepTx2="2/2 Transaction in progress.\nPlease wait for it to finish.\nThis may take a few minutes";

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const approved = await erc20Fund.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueFundBi)
            {
                App.gui.setTxLockText(stepTx1);
                const approveResult = await erc20Fund.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueFundBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
                App.gui.setTxLockText(stepTx2);
            }
        } 
        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const approved = await erc20Anchor.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueAnchorBi)
            {
                App.gui.setTxLockText(stepTx1);
                const approveResult = await erc20Anchor.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueAnchorBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
                App.gui.setTxLockText(stepTx2);
            }
        }
        const result = await this._lpxInf.lpxCtrlPools.addLiquidity(BiMath.ToEth(valuePayBi), this._poolId, BiMath.ToEth(valueFundBi), BiMath.ToEth(valueAnchorBi));
        if (result) this._informTxSuccessful();
        App.gui.setTxLockText(stepTx0);
        this._lpxInf.refreshAsync();
    }

    

    private async _tryClaimYieldAsync()
    {
        const result = await this._lpxInf.lpxCtrlPools.claimProfits(this._poolId,[App.chain.account]);
        if (result) this._informTxSuccessful();
        this._lpxInf.refreshAsync();
    }

    private async _tryRemoveLiquidityAsync()
    {
        const value = this.ctrls.rRemoveLiquidityPart.value;
        if (!value) return;
        if (!this._share) { return; }
        if (!this._config) {return; }
        const takeShare = this._share.share*BigInt(value)/BigInt(100);
        const result = await this._lpxInf.lpxCtrlPools.removeLiquidity(this._poolId,BiMath.ToEth(takeShare));
        if (result) this._informTxSuccessful();
        this._lpxInf.refreshAsync();
    }

    private _informTxSuccessful() { App.gui.dialogOkShowAsync("✅Transaction successful!","") }
}